// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Alert {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.Alert ion-content {
  flex: 1;
}
.Alert p {
  font-size: 16px;
  line-height: 1.5;
}
.Alert__Button {
  --border-radius: 4px;
}
.Alert__Button:first-of-type {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./libs/features/shared/components/src/lib/alert-dialog/alert-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,OAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;AAAJ;AAGE;EACE,oBAAA;AADJ;AAGI;EACE,oBAAA;AADN","sourcesContent":[".Alert {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  ion-content {\n    flex: 1;\n  }\n\n  p {\n    font-size: 16px;\n    line-height: 1.5;\n  }\n\n  &__Button {\n    --border-radius: 4px;\n\n    &:first-of-type {\n      margin-right: 0.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
